<template lang="pug">

.card
  .card-header.border-0.pt-6
    .card-toolbar
      h3.card-title.align-items-start.flex-column
        span.card-label.fw-bolder.fs-3.mb-1
          | Últimos consentimentos
        span.text-muted.fw-bold.fs-7 Real-time
    .card-title
      .d-flex.align-items-center.position-relative.my-1
        router-link.btn.btn-lg.btn-primary(:to="{ name: 'siteDetailsConsents', params: { id: siteId } }")
          | Ver todos
  .card-body.pt-0
    #kt_table_users_wrapper.dataTables_wrapper.dt-bootstrap4.no-footer
      .table-responsive
        table#kt_table_users.table.align-middle.table-row-dashed.fs-6.gy-5.dataTable.no-footer
          thead
            tr.text-start.text-muted.fw-bolder.fs-7.text-uppercase.gs-0
              th.min-w-125px.sorting(tabindex='0' aria-controls='kt_table_users' rowspan='1' colspan='1' aria-label='User: activate to sort column ascending' style='width: 257.422px')
                | Identificação única
              th.min-w-125px.sorting(tabindex='0' aria-controls='kt_table_users' rowspan='1' colspan='1' aria-label='Last login: activate to sort column ascending' style='width: 145.234px')
                | Data
              th.min-w-125px.sorting(tabindex='0' aria-controls='kt_table_users' rowspan='1' colspan='1' aria-label='Two-step: activate to sort column ascending' style='width: 145.234px')
                | Categorias
              th.min-w-125px.sorting(tabindex='0' aria-controls='kt_table_users' rowspan='1' colspan='1' aria-label='Joined Date: activate to sort column ascending' style='width: 90.625px')
                | Consentimentos
              th.text-end.min-w-100px.sorting_disabled(rowspan='1' colspan='1' aria-label='Actions' style='width: 113.5px')
                | Detalhes
          tbody.text-gray-600.fw-bold
            template(v-for='consent in consentsFormated' :key='consent.id')
              tr.odd
                td.d-flex.align-items-center
                  .d-flex.flex-column
                    a.text-gray-800.text-hover-primary.mb-1(data-bs-toggle="modal" data-bs-target="#showDetails" @click="setConsentToShow(consent)")
                      | {{ consent.id }}
                    span {{ consent.since }}
                td(data-order='2021-07-25T10:30:00-03:00')
                  | {{ consent.created }}
                td
                  | {{ consent.category }}
                td
                  .badge.fw-bolder(:class='`badge-light-${consent.style}`')
                    | {{ consent.type }}
                td.text-end
                  a.btn.btn-light.btn-active-light-primary.btn-sm(data-bs-toggle="modal" data-bs-target="#showDetails" @click="setConsentToShow(consent)")
                    | Visualizar

#showDetails.modal.fade(tabindex='-1')
  .modal-dialog.modal-lg.modal-dialog-centered.text-centered
    .modal-content.showModalConsents.py-5.px-5
      .modal-header.pb-0.border-0.d-flex.justify-content-end
        .btn.btn-sm.btn-icon.btn-active-color-primary(data-bs-dismiss='modal')
          span.svg-icon.svg-icon-1
            inline-svg(src='/media/icons/duotune/arrows/arr061.svg')
      .modal-body.scroll-y.mx-5.mx-xl-10.pt-0.pb-15
        .text-center.mb-13
          h1.d-flex.justify-content-center.align-items-center.mb-3 Visualização de consentimento
          .text-muted.fw-bold.fs-5
            | Identificação única: 
            span.link-primary.fw-bolder(href='#') {{ consentToShow.id }}
            | .
          .text-muted.fw-bold.fs-5
            | IP: 
            span.link-primary.fw-bolder(href='#') {{ consentToShow.ip }}
            | .
          .text-muted.fw-bold.fs-5
            | {{ consentToShow.rawDate }}
        .mh-475px.scroll-y.me-n7.pe-7
          .border.border-hover-primary.p-7.rounded.mb-7(v-for="consent in consentsFromConsent")
            .d-flex.flex-stack.pb-3
              .d-flex
                .d-flex.align-items-center
                  a.text-dark.fw-bolder.text-hover-primary.fs-5.me-4(href='/metronic8/demo1/../demo1/pages/profile/overview.html') {{ consent._id.name }}
              .d-flex
                .text-end.pb-3
                  span.text-dark.fw-bolder.fs-5 {{consent.cookies.length}}
                  span.text-muted.fs-7 / {{consentToShow.version.categories[consent._id._id].length}} Cookies
            .p-0
              .d-flex.flex-column       
                p.text-gray-700.fw-bold.fs-6.mb-4 {{ consent._id.description }}
                .d-flex.text-gray-700.fw-bold.fs-7
                  template(v-for="cookie in consent.cookies")
                    span.border.border-2.border-success.rounded.me-3.p-1.px-2 {{ cookie.name }}
                  template(v-for="versionCookie in consentToShow.version.categories[consent._id._id]")
                    span.border.border-2.border-danger.rounded.me-3.p-1.px-2.mb-1(v-if="consentToShow.whitelist.indexOf(versionCookie) < 0") {{ versionCookie }}
              //- .d-flex.flex-column 
              //-   .separator.separator-dashed.border-muted.my-5
              //-   .d-flex.flex-stack
              //-     .d-flex.flex-column.mw-200px
              //-       .d-flex.align-items-center.mb-2
              //-         span.text-gray-700.fs-6.fw-bold.me-2 90%
              //-         span.text-muted.fs-8 Aceitação
              //-       .progress.h-6px.w-200px
              //-         .progress-bar.bg-primary(role='progressbar' style='width: 90%' aria-valuenow='90' aria-valuemin='0' aria-valuemax='100')

</template>

<script>
import { defineComponent, computed, ref } from "vue";
import { useRoute } from "vue-router";
import { ConsentIP } from "@/core/services/consensu/consents";
import moment from "moment";

export default defineComponent({
  name: "LastConsents",

  props: {
    consents: { type: Array, required: true },
  },

  setup(props) {
    const route = useRoute();
    const siteId = route.params.id;
    const consentToShow = ref({});

    const type = {
      all: {
        name: "Todos",
        style: "success",
      },
      custom: {
        name: "Personalizado",
        style: "warning",
      },
      optout: {
        name: "Optout",
        style: "danger",
      },
    };

    const consentsFormated = computed(() => {
      let arrayFormated = [];

      if (props.consents) {
        props.consents.forEach((consent) => {
          let categories = consent.consents.map((category) => {
            return category._id.name;
          });

          let formated = {
            id: consent._id,
            since: moment(consent.createdAt, "", "America/Sao_Paulo")
              .locale("pt-br")
              .fromNow(),
            created: moment(consent.createdAt, "", "America/Sao_Paulo")
              .locale("pt-br")
              .format("DD/MM/YYYY, h:mm a"),
            rawDate: moment(consent.createdAt, "", "America/Sao_Paulo")
              .locale("pt-br")
              .format("DD/MM/YYYY, h:mm a"),
            category: categories.join(", "),
            type: type[consent.type].name,
            style: type[consent.type].style,
            consent: consent,
            version: makeVersion(consent.version) || {},
            whitelist: makeWhiteList(consent.consents),
          };

          arrayFormated.push(formated);
        });
      }

      return arrayFormated;
    });

    const consentsFromConsent = computed(() => {
      return consentToShow.value.consent
        ? consentToShow.value.consent.consents
        : {};
    });

    const setConsentToShow = async (consent) => {
      await ConsentIP(consent.id).then(({ data }) => {
        consent.ip = data.ip;
        consentToShow.value = consent;
      });
    };

    const makeVersion = (version) => {
      let categories = {};
      version.cookies.forEach((cookie) => {
        if (!categories[cookie.category]) categories[cookie.category] = [];
        categories[cookie.category].push(cookie.name);
      });
      return { _id: version._id, categories };
    };

    const makeWhiteList = (categories) => {
      let whitelist = [];
      categories.forEach((category) => {
        whitelist = whitelist.concat(
          category.cookies.map((cookie) => {
            return cookie.name;
          })
        );
      });
      return whitelist;
    };

    return {
      consentsFormated,
      setConsentToShow,
      consentToShow,
      consentsFromConsent,
      siteId,
    };
  },
});
</script>

<style></style>
